import { Component, inject, OnInit, output, signal } from '@angular/core';
import { faFolder, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { CompanyArchive } from '@infodocs/portfolio/interfaces/company-archive';
import { CompanyArchiveService } from '@infodocs/portfolio/services/company-archive.service';
import { ComponentLoaderComponent } from '@infodocs/shared/components/component-loader/component-loader.component';
import { IconComponent } from '@infodocs/shared/components/icon/icon.component';
import { HasObservablesComponent } from '@infodocs/shared/has-observables.component';
import { AlertModule } from 'ngx-bootstrap/alert';
import { takeUntil } from 'rxjs';

@Component({
	selector: 'app-archived-companies-table',
	templateUrl: './archived-companies-table.component.html',
	styleUrl: './archived-companies-table.component.scss',
	imports: [ComponentLoaderComponent, AlertModule, IconComponent],
})
export class ArchivedCompaniesTableComponent extends HasObservablesComponent implements OnInit {
	readonly back = output<void>();
	readonly viewArchive = output<CompanyArchive>();

	private readonly archiveService = inject(CompanyArchiveService);

	protected readonly faFolderIcon = faFolder;
	protected readonly faFolderOpenIcon = faFolderOpen;
	protected readonly isLoading = signal(true);
	protected readonly errorMessage = signal<string | undefined>(undefined);
	protected readonly archives = signal<CompanyArchive[]>([]);
	protected readonly openFolder = signal(false);
	protected readonly hoveredRowId = signal<number | null>(null);

	public ngOnInit(): void {
		this.loadArchives();
	}

	protected onView(archive: CompanyArchive): void {
		this.viewArchive.emit(archive);
	}

	protected onBack(): void {
		this.back.emit();
	}

	protected toggleFolderOpen(open: boolean, rowId: number | null): void {
		this.hoveredRowId.set(rowId);
		this.openFolder.set(open);
	}

	private loadArchives(): void {
		this.isLoading.set(true);
		this.errorMessage.set(undefined);

		this.archiveService
			.listArchives()
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: archives => {
					this.archives.set(archives);
					this.isLoading.set(false);
				},
				error: () => {
					this.errorMessage.set('We could not load archived companies. Please try again.');
					this.isLoading.set(false);
				},
			});
	}
}
